export default "/images/pr-img-2.png?dac4be2a91714e68568fef3d38fd4496";